import { UnitcodeResponseModel, AllUnitcodeResponseModel, PlantsDropDownResponse, PlantIdRequest } from '@gtpl/shared-models/masters';
import { InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError, errorHandler, ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { Any } from 'typeorm';
import { UnitCodeDTO } from './dto/unit-codes.dto';
import { UnitCodesService } from './unit-codes.service';
import { UnitcodeRequest } from './dto/unit-code.request'
import { UserRequestDto } from '../countries/dto/user-request-dto';
@ApiTags('unitcodes')
@Controller('unitcode')
export class UnitCodesController {
  constructor(private unitcodeService: UnitCodesService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler
  ) { }


  @Post('/createUnitcode')
  async createUnitcode(@Body() unitcodeDTO: UnitCodeDTO, isUpdate: boolean = false): Promise<UnitcodeResponseModel> {
    try {
      return await this.unitcodeService.createUnitcode(unitcodeDTO, false);
    } catch (error) {
      // return errorHandler(DestinationResponseModel,error);
      return this.applicationExceptionHandler.returnException(UnitcodeResponseModel, error);
    }
  }


  @Post('/updateUnitcode')
  async updateUnitcode(@Body() unitcodeDTO: UnitCodeDTO): Promise<UnitcodeResponseModel> {
    try {
      return await this.unitcodeService.createUnitcode(unitcodeDTO, true);
    } catch (error) {
      // return errorHandler(DestinationResponseModel, error);
      return this.applicationExceptionHandler.returnException(UnitcodeResponseModel, error);
    }
  }
  @Post('/getAllUnitcodes')
  async getAllUnitcodes(@Body() req?:UserRequestDto): Promise<AllUnitcodeResponseModel> {
    try {
      return await this.unitcodeService.getAllUnitcodes(req);
    } catch (error) {
      // return errorHandler(AllDestinationsResponseModel, error);
      return this.applicationExceptionHandler.returnException(AllUnitcodeResponseModel, error);
    }
  }
  @Post('/getAllActiveUnitcodes')
  async getAllActiveUnitcodes(): Promise<AllUnitcodeResponseModel> {
    try {
      return await this.unitcodeService.getAllActiveUnitcodes();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllUnitcodeResponseModel, error)
    }
  }

  @Post('/activateorDeactivateUnitcode')
  async activateorDeactivateUnitcode(@Body() unitcodereq: UnitcodeRequest): Promise<UnitcodeResponseModel> {
    try {

      return await this.unitcodeService.activateOrDeactivateUnitcode(unitcodereq)
    } catch (err) {
      return this.applicationExceptionHandler.returnException(UnitcodeResponseModel, err);
    }
  }

  @Post('/getAllMainPlants')
  async getAllMainPlants(): Promise<PlantsDropDownResponse> {
    try {
      return await this.unitcodeService.getAllMainPlants()
    } catch (err) {
      return this.applicationExceptionHandler.returnException(PlantsDropDownResponse, err);
    }
  }

  @Post('/getAllMainAndSubContractPlants')
  async getAllMainAndSubContractPlants(): Promise<PlantsDropDownResponse> {
    try {
      return await this.unitcodeService.getAllMainAndSubContractPlants()
    } catch (err) {
      return this.applicationExceptionHandler.returnException(PlantsDropDownResponse, err);
    }
  }

  

  @Post('/getAllSubContractorPlants')
  async getAllSubContractorPlants(): Promise<PlantsDropDownResponse> {
    try {
      return await this.unitcodeService.getAllSubContractorPlants()
    } catch (err) {
      return this.applicationExceptionHandler.returnException(PlantsDropDownResponse, err);
    }
  }

  
  @Post('/getAllMainAndHoPlants')
  async getAllMainAndHoPlants(): Promise<PlantsDropDownResponse> {
    try {
      return await this.unitcodeService.getAllMainAndHoPlants()
    } catch (err) {
      return this.applicationExceptionHandler.returnException(PlantsDropDownResponse, err);
    }
  }
  @Post('/getAllSubPlants')
  async getAllSubPlants(): Promise<PlantsDropDownResponse> {
    try {
      return await this.unitcodeService.getAllSubPlants()
    } catch (err) {
      return this.applicationExceptionHandler.returnException(PlantsDropDownResponse, err);
    }
  }

  @Post('/getAllPlants')
  async getAllPlants(): Promise<PlantsDropDownResponse> {
    try {
      return await this.unitcodeService.getAllPlants()
    } catch (err) {
      return this.applicationExceptionHandler.returnException(PlantsDropDownResponse, err);
    }
  }


  @Post('/getPlantDetailsById')
  async getPlantDetailsById(@Body() unitcodeReq: PlantIdRequest): Promise<UnitcodeResponseModel> {
    try {
      return await this.unitcodeService.getPlantDetailsById(unitcodeReq);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(UnitcodeResponseModel, err);
    }
  }

}